<template>
  <div
    id="top"
    class="min-h-screen overflow-x-clip bg-secondary-light text-ternary-dark transition-colors duration-500 dark:bg-primary-dark dark:text-ternary-light"
  >
    <TheHeader />
    <main>
      <HeroSection />
      <AboutSection />
      <TechStackSection />
      <ProjectsSection />
    </main>
    <TheFooter />
    <CustomBackToTop />
  </div>
</template>

<script setup>
import CustomBackToTop from '@/components/base/CustomBackToTop.vue';
import TheFooter from '@/components/layout/TheFooter.vue';
import TheHeader from '@/components/layout/TheHeader.vue';
import AboutSection from '@/components/sections/AboutSection.vue';
import HeroSection from '@/components/sections/HeroSection.vue';
import ProjectsSection from '@/components/sections/ProjectsSection.vue';
import TechStackSection from '@/components/sections/TechStackSection.vue';
import { useTheme } from '@/composables/useTheme';

useTheme().initTheme();
</script>
